'use client'

import { createContext, type ReactNode, use } from 'react'

export type MenuView = 'main' | 'projects' | 'workspaces'

export interface MobileMenuContextValue {
  currentView: MenuView
  navigateToMain: () => void
  navigateToProjects: () => void
  navigateToWorkspaces: () => void
  onClose: () => void
  onOpenWorkspaceSettings?: () => void
  onOpenProjectSettings?: () => void
  onOpenProjectMembers?: () => void
  onInviteProjectClick?: () => void
  onInviteWorkspaceClick?: () => void
  onCreateProject?: () => void
}

const MobileMenuContext = createContext<MobileMenuContextValue | null>(null)

export function useMobileMenuContext() {
  const context = use(MobileMenuContext)
  if (!context) {
    throw new Error('useMobileMenuContext must be used within MobileMenuProvider')
  }
  return context
}

interface MobileMenuProviderProps {
  children: ReactNode
  value: MobileMenuContextValue
}

export function MobileMenuProvider({ children, value }: MobileMenuProviderProps) {
  return <MobileMenuContext value={value}>{children}</MobileMenuContext>
}
